module.exports = ".head{\n  text-align: center;\n}\n.cimage{\n  padding-bottom: 20px;\n}\n"